module.exports = __webpack_public_path__ + "static/media/quiet-is-new-loud.bbe0e241.jpg";